export interface Image {
  abbreviation?: string;
  color?: string;
  id?: number;
  object?: any;
  small?: any;
  tiny?: any;
}
